import { AxiosError } from 'axios';
import { ActionType } from 'typesafe-actions';
import * as actions from './actions';
import { User } from '../auth';

export type InvoicesAction = ActionType<typeof actions>;

export interface InvoicesState {
  invoices: {
    data: Invoice[] | null;
    loading: boolean;
    error: AxiosError | null;
  };
  invoice: {
    data: Invoice | null;
    loading: boolean;
    error: AxiosError | null;
  };
}

export interface InvoiceParams {
  enterpriseId: string;
  projectId?: string;
  invoiceId?: string;
  invoice?: any;
  approvalType?: string;
  filterData?: any;
  idList?: number[];
  bulkStatus?: string;
  declineReason?: string;
}

export interface InvoiceResponse {
  invoices?: Invoice[];
  invoiceId?: number;
  success: boolean;
  message: any;
}

export enum InvoiceStatus {
  APPROVING = '0',
  APPROVED = '1',
  DECLINED = '2',
  PAYMENT_COMPLETED = '3',
  DRAFT = '4',
}

export enum InvoiceApprovalType {
  REQUEST_APPROVAL = '0',
  DECLINE_APPROVAL = '1',
  CANCEL_APPROVAL = '2',
  RECALL_APPROVAL = '3',
  PAYMENT_APPROVAL = '4',
}

export const invoiceStatusKorean = {
  '0': '승인중',
  '1': '승인완료',
  '2': '반려',
  '3': '지급완료',
  '4': '작성중',
} as const;

export enum InvoiceType {
  Invoice = '0',
  TradingStatement = '1',
}

export interface Invoice {
  id: number;
  price: number;
  vat: number;
  billingDate: string;
  gongjong: string;
  category: string;
  type: InvoiceType;
  status: InvoiceStatus;
  isCreditTransaction: boolean;
  description: string;
  submittedBy: any;
  project: any;
  enterprise: any;
  vendor: any;
  file: any[];
  approver: any;
  approvalConfig: any;
  invoiceHistories: any[];
  payments: any[];
  children: Invoice[];
  createdAt: string;
  updatedAt: string;
}

export interface InvoiceHistory {
  id: number;
  user: User;
  description: string;
  createdAt: string;
}

export interface Payment {
  id: number;
  amount: number;
  paymentDate: string;
  description: string;
  createdAt: string;
}
